import { render, staticRenderFns } from "./GridVXScroll.vue?vue&type=template&id=5a8c9c13&"
import script from "./GridVXScroll.vue?vue&type=script&lang=js&"
export * from "./GridVXScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports